/**
 * Sticky Header Module
 * Adds/removes 'sticky' class to header and hamburger on scroll.
 */
function initStickyHeader() {
  const header = document.querySelector('header');
  const hamburger = document.querySelector('.hamburger');

  if (!header) return;

  function updateSticky() {
    const scrolled = window.scrollY > 0;

    header.classList.toggle('sticky', scrolled);
    if (hamburger) {
      hamburger.classList.toggle('sticky', scrolled);
    }
  }

  updateSticky();
  window.addEventListener('scroll', updateSticky, { passive: true });
}
